import CustomLayout from './src/utils/wrapPageElement'
export const wrapPageElement = CustomLayout
